import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useSaleOrderDetailModel } from "./saleOrderDetailModel";
import { formatNum } from "@/utils/utils";

export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { addDesc, editDesc, lookDesc } = useSaleOrderDetailModel();
    const typeDesc = {
        add: addDesc,
        edit: editDesc,
        look: lookDesc
    }
    const orderStatistics: IDescription[] = [
        {
            label: "订单数量",
            value: formatNum(typeDesc[mode].numAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "订单项数",
            value: formatNum(typeDesc[mode]?.itemNumAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "订单金额",
            value: formatNum(typeDesc[mode].notTotalAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "优惠金额",
            value: formatNum(typeDesc[mode].discountAll),
            color: DescriptionColorEnum.green,
            status: true
        },
        {
            label: "应收金额",
            value: formatNum(typeDesc[mode].totalAll),
            color: DescriptionColorEnum.red,
            status: true
        }
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}